import type { ThematicConfig } from '#types/config/components/thematic'

export default {
  brandClasses: {
    title: 'title-2 text-center'
  }
} satisfies ThematicConfig
